import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

export default class SvgIcon extends Component {
  render() {
    const { symbol, className, style, size } = this.props;
    const classNameSafeId = symbol.id && symbol.id.replace(/[^a-zA-Z0-9-_]/g, "_");
    const iconClassName = cx(className, {
      "phx-icon": true,
      [`phx-icon-${size}`]: !!size,
      [`phx-icon-${classNameSafeId}`]: classNameSafeId,
    });

    return (
      <svg className={iconClassName} style={style} viewBox={symbol.viewBox}>
        <use xlinkHref={`#${symbol.id}`} />
      </svg>
    );
  }
}

SvgIcon.defaultProps = {
  className: null,
  style: null,
  size: "",
};

SvgIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOf(["", "xs", "sm", "lg", "xl"]),
  symbol: PropTypes.shape({
    viewBox: PropTypes.string,
    id: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
};

require("./index.less");